import { useEffect } from "react";

export default function JsonLd({ data }) {
  const json = JSON.stringify(data);
  useEffect(() => {
    const el = document.createElement("script");
    el.type = "application/ld+json";
    el.text = json;
    document.head.appendChild(el);
    return () => { try { document.head.removeChild(el); } catch {} };
  }, [json]);
  return null;
}
